<section class="skeleton-table-01">
    <div
      *ngFor="let cell of [].constructor(totalCells); let i = index; trackBy: trackByIndex"
      class="skeleton-section"
      [style.height]="getHeightForRow(i)"
      [style.flex]="'0 0 calc(100% / ' + columns + ' - 4px)'"
    >
      <div style="visibility: hidden;">tab</div>
    </div>
  </section>
  